import * as S from './style';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import mainBanner1 from '@/assets/img/banner/banner_main01.jpg';
import shareIcon from '@/assets/img/icon/shareIcon.svg';
import LineIcon from '@/components/Icon/lineIcon';
import SingleArrowPrev from '@/components/Icon/SingleArrowPrev';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import { useState } from 'react';
import ModalShare from '@/components/common/Modal/ModalShare/ModalShare';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import { useGetConferenceDetailApi } from '@/api/conference';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { downloadFile } from '@/utils/fileUtils';
import { formatBytesToKB } from '@/utils/formatting';
import DownloadIcon from '@/components/Icon/DownloadIcon';

const ConferenceDetail = () => {
	const params = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const paramsMenu = location.state?.menu ?? '학술대회 안내';
	const [isOpenShare, setIsOpenShare] = useState(false);
	const { id } = params;
	const handleOpenModalShare = (bool: boolean) => {
		setIsOpenShare(bool);
	};
	const { data: infoDetailData } = useGetConferenceDetailApi({
		conference_pk: id ?? '',
	});

	return (
		<>
			<main>
				<SubBanner subTitle="Academic conference" title="학술대회" img={mainBanner1} />
				<S.ConferenceContainer>
					<S.ConferenceHeader>
						<S.ConferenceTitlebox>
							<S.ConferenceTitle>{infoDetailData?.conference.guide_title}</S.ConferenceTitle>
							<S.ConferenceSubTitle>
								{dayjs(infoDetailData?.conference.guide_enrollment_date).format('YYYY-MM-DD') ?? ''}
								<LineIcon />
								조회수: {infoDetailData?.conference.guide_hit ?? '0'}
								<LineIcon />
								작성자: {infoDetailData?.conference.admin_name}
							</S.ConferenceSubTitle>
						</S.ConferenceTitlebox>
						<div className="share_icon">
							<S.ImgBox onClick={() => setIsOpenShare(!isOpenShare)}>
								<img src={shareIcon} alt="share" />
							</S.ImgBox>
						</div>
					</S.ConferenceHeader>
					<S.ContentBox>
						<S.Content dangerouslySetInnerHTML={{ __html: infoDetailData?.conference.guide_content ?? '' }} />
						<S.DownLoadBoxList>
							{infoDetailData &&
								infoDetailData.conference_file.map((item, index) => (
									<S.DownLoadBox key={index} onClick={() => downloadFile(item.file_path ?? '', String(item.file_pk) ?? '')}>
										<S.DownLoadContent>
											<div className="title">{item.file_original_name ?? ''}</div>
											<div className="sub_title">{formatBytesToKB(item.file_size ?? 0)}</div>
										</S.DownLoadContent>
										<DownloadIcon iconColor="#ADB5BD" width="20" height="20" />
									</S.DownLoadBox>
								))}
						</S.DownLoadBoxList>
						<S.MenuBox>
							<S.MenuList>
								{!infoDetailData?.prev_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/conference/detail/${infoDetailData?.prev_pk}`, { state: { menu: paramsMenu } })}>
										<SingleArrowPrev iconColor="#212529" width="18" height="18" /> 이전글
									</S.Menu>
								)}{' '}
								{!infoDetailData?.next_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/conference/detail/${infoDetailData?.next_pk}`, { state: { menu: paramsMenu } })}>
										다음글
										<SingleArrowNext iconColor="#212529" width="18" height="18" />
									</S.Menu>
								)}
							</S.MenuList>
							<S.MenuList>
								<S.MenuActive type="button" onClick={() => navigate(`/conference`, { state: { menu: paramsMenu } })}>
									목록
								</S.MenuActive>
							</S.MenuList>
						</S.MenuBox>
					</S.ContentBox>
				</S.ConferenceContainer>
			</main>
			{isOpenShare && (
				<ModalPortal>
					<ModalShare onClick={handleOpenModalShare} />
				</ModalPortal>
			)}
		</>
	);
};
export default ConferenceDetail;
